import { render, staticRenderFns } from "./ReporteIngresoDetalle.vue?vue&type=template&id=437fec6e&scoped=true"
import script from "./ReporteIngresoDetalle.vue?vue&type=script&lang=js"
export * from "./ReporteIngresoDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437fec6e",
  null
  
)

export default component.exports